import { SelectMenu } from '@scale/scaleui';
import {
  InteractionStepParams,
  BEFORE_MOCK_TEMPLATES,
  TURN_MOCK_TEMPLATES,
  QIR_MOCK_TEMPLATES,
  AFTER_MOCK_TEMPLATES,
} from '@scale/shared/types/chat';
import { memo } from 'react';
import uuid from 'uuid';

type Props = {
  onSubmit: (template: InteractionStepParams) => void;
  property: 'before' | 'turn' | 'after' | 'qir';
};
const getTemplatesForProperty = (property: 'before' | 'turn' | 'after' | 'qir') => {
  switch (property) {
    case 'before':
      return BEFORE_MOCK_TEMPLATES;
    case 'turn':
      return TURN_MOCK_TEMPLATES;
    case 'after':
      return AFTER_MOCK_TEMPLATES;
    case 'qir':
      return QIR_MOCK_TEMPLATES;
  }
};

const StepJsonCreator = ({ onSubmit, property }: Props) => {
  const templates = getTemplatesForProperty(property);
  return (
    <div className="flex flex-col gap-2">
      <SelectMenu
        options={[
          {
            id: '',
            name: 'Select a template to add a new step',
          },
          ...Object.keys(templates).map(name => ({ id: name, name })),
        ]}
        selectedOptionId={''}
        setSelected={template => {
          if (template) {
            const templateWithId: InteractionStepParams = {
              ...templates[template],
              id: uuid.v4(),
            };

            onSubmit(templateWithId);
          }
        }}
        menuDirection="bottom-left"
      />
    </div>
  );
};

export default memo(StepJsonCreator);
